import _ from 'underscore';

import { ADD_LOCATION_DATA, DELETE_FETCHING_LOCATION_DATA, SET_FETCHING_LOCATION_DATA } from '../actionTypes/location';

const INITIAL_STATE = {
    data: {},
    currentlyFetchingLocation: {},
};

export default function LocationReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case ADD_LOCATION_DATA: {
            return {
                ...state,
                data: {
                    ...state.data,
                    [action.key]: action.data,
                },
            };
        }
        case DELETE_FETCHING_LOCATION_DATA: {
            return {
                ...state,
                currentlyFetchingLocation: _.omit(state.currentlyFetchingLocation, action.locationKey),
            };
        }
        case SET_FETCHING_LOCATION_DATA: {
            return {
                ...state,
                currentlyFetchingLocation: {
                    ...state.currentlyFetchingLocation,
                    [action.locationKey]: true,
                },
            };
        }
        default:
            return state;
    }
}
